import { defineComponent as t, computed as n } from "vue";
const i = t({
  name: "CsButtonLoadingSpinner",
  props: {
    size: {
      type: Number,
      default: 28
    },
    circleColor: {
      type: String,
      default: "#fff"
    }
  },
  setup(e) {
    return {
      finalSize: n(() => e.size + "px")
    };
  }
});
export {
  i as default
};
